var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Splash',[_c('img',{staticClass:"splash-logo",attrs:{"src":require("@/assets/images/paypredict-logo.svg")}}),_c('br'),_c('br'),_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }